import { useCallback, useState } from "react"
import { Order, TipoArticulo, useGetAlmacenesArticulosSuggetionsLazyQuery } from "src/gql/schema"
import { useProfile } from "src/shared/hooks/useProfile"
import { debounce } from "src/utils/lodash"

export function useSuggestionArticulo(tipo_articulo: TipoArticulo.Receta | TipoArticulo.Proceso | null = null) {
    const { hotel_id } = useProfile()
    const [suggestion, setSuggestion] = useState<string>("")

    const [searchArticulos] = useGetAlmacenesArticulosSuggetionsLazyQuery()

    const lower = (value: string) => value.trim().toLowerCase()

    const compareValue = (value: string, name: string) => {
        const label = lower(name.slice(0, value.length))
        return label === lower(value)
    }

    const fetchData = (value: string, fetch: boolean) => {
        if (!fetch || !value.length) {
            setSuggestion("")
            return
        }

        if (value.length >= 3) {
            searchArticulos({
                variables: {
                    hotel_id: null,
                    pagination_options: { take: 5, page: 1, order: Order.Asc },
                    filter_tipo_articulo: tipo_articulo,
                    nameFilter: value,
                },
            })
                .then(({ data }) => {
                    const values: string[] = []
                    data?.almacenes_articulos?.almacenes_articulos?.forEach((i) => {
                        const nombre = i?.articulo?.nombre || ""
                        if (nombre && i?.hotel_id !== hotel_id && compareValue(value, nombre)) {
                            values.push(nombre)
                        }
                    })
                    console.log({values})
                    setSuggestion(values?.[0] || "")
                })
                .catch((e) => console.log(e))
        }
    }

    const handleSearch = useCallback(
        debounce((value: string, fetch: boolean) => fetchData(value, fetch), 500),
        [hotel_id]
    )

    return {
        suggestion,
        handleSearch,
    }
}
